import type {
  MarketActionsV2Action,
  MarketActionsV2EntryPoint,
  MarketLendWithdrawSource
} from '../events'
import { trackAnalyticsEvent } from '../track'

export interface MarketActionsV2EntryParams {
  entryPoint: MarketActionsV2EntryPoint
  action: MarketActionsV2Action
  marketId: string
  chainId: number
  chainName: string
  source?: MarketLendWithdrawSource
}

/**
 * Impression — the market-actions-v2 entry point (a Simple Action Panel tab or a
 * Position Manager dialog) was rendered. Fired once per mount via
 * `useTrackMarketActionsV2EntryViewed`.
 */
export function trackMarketActionsV2EntryViewed(params: MarketActionsV2EntryParams) {
  trackAnalyticsEvent('market_actions_v2_entry_viewed', {
    entry_point: params.entryPoint,
    action: params.action,
    market_id: params.marketId,
    chain_id: params.chainId,
    chain_name: params.chainName,
    ...(params.source ? { source: params.source } : {})
  })
}

/**
 * Click — the user pressed the entry point's CTA (opening the review dialog).
 * Conversion is covered downstream by `checkoutTracking` on `submitTransactions`.
 */
export function trackMarketActionsV2EntryClicked(params: MarketActionsV2EntryParams) {
  trackAnalyticsEvent('market_actions_v2_entry_clicked', {
    entry_point: params.entryPoint,
    action: params.action,
    market_id: params.marketId,
    chain_id: params.chainId,
    chain_name: params.chainName,
    ...(params.source ? { source: params.source } : {})
  })
}
